// packages/front/src/portfolio/date-selector.tsx

import { useEffect, useState, type ChangeEvent, type FC } from "react";

export interface DateSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export const DateSelector: FC<DateSelectorProps> = ({ value, onChange }) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized && !value) {
      const today = new Date().toISOString().slice(0, 10);
      onChange(today);
      setInitialized(true);
    } else if (!initialized) {
      setInitialized(true);
    }
  }, [initialized, onChange, value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <input
      type="date"
      value={value}
      onChange={handleChange}
      data-testid="date-selector"
      className="h-9 rounded-md border border-input bg-background px-3 py-1 text-sm"
    />
  );
};
